import {
  ComponentLabel,
  UiZoneWidgetConfig,
  WidgetFields,
  WidgetNames,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export const mapQuickLinksWidgetFunction = function mapQuickLinksWidget(
  item: WorkflowWidgetConfig,
): UiZoneWidgetConfig {
  const elementsConfig = item.widgetConfiguration.attributes?.elementsConfig;

  let quickLinksWidget = true;

  const elementConfig = elementsConfig.find(
    (item) => item.field_name === WidgetNames.QUICK_LINKS_WIDGET,
  ) as WidgetFields;
  quickLinksWidget = elementConfig?.show;

  const label = item.widgetConfiguration?.attributes['label'];
  const slug = item.widgetConfiguration?.attributes['slug'];
  const url = item.widgetConfiguration?.attributes['url'];
  const externalUrl = item.widgetConfiguration?.attributes['externalUrl'];
  const browserBehaviour = item.widgetConfiguration?.attributes['browserBehaviour'];

  return {
    name: item.name as ComponentLabel,
    attributes: {
      ...item.widgetConfiguration.attributes,
      showQuickLinksWidget: quickLinksWidget,
      label,
      slug,
      url,
      browserBehaviour,
      externalUrl,
      title: label,
    },
    uniqueId: item.uniqueId,
    gridPosition: item.gridPosition,
  };
};
